/** 全角（占 2 个单位宽）字符判定：CJK 区段 + 全角标点/假名等。 */
const FULLWIDTH = /[\u3000-\u303F\u3040-\u30FF\u3100-\u312F\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF\uFE30-\uFE4F\uFF01-\uFF60\uFFE0-\uFFE6]/;

/** 单字符显示宽度：全角记 2、半角记 1。 */
function charWidth(ch: string): number {
  return FULLWIDTH.test(ch) ? 2 : 1;
}

/**
 * 按显示宽度截断文本：预算默认 12 个半角单位（≈ 最多 6 个汉字或 12 个英文字符）。
 * 超预算时直接截足字数，不加省略号。
 */
export function truncateByWidth(text: string, budget = 12): string {
  let out = '';
  let width = 0;
  for (const ch of text) {
    const w = charWidth(ch);
    if (width + w > budget) break;
    out += ch;
    width += w;
  }
  return out;
}
